/**
 * Audio utilities for Web Audio API
 */

/**
 * Create an audio analyzer from a media stream
 */
export const createAudioAnalyzer = (stream) => {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const analyzer = audioContext.createAnalyser();
    const source = audioContext.createMediaStreamSource(stream);
    
    analyzer.fftSize = 256;
    source.connect(analyzer);
    
    return { audioContext, analyzer };
};

/**
 * Get frequency data from analyzer
 */
export const getFrequencyData = (analyzer) => {
    const bufferLength = analyzer.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);
    analyzer.getByteFrequencyData(dataArray);
    return dataArray;
};

/**
 * Calculate average audio level (0-255)
 */
export const getAudioLevel = (frequencyData) => {
    let sum = 0;
    for (let i = 0; i < frequencyData.length; i++) {
        sum += frequencyData[i];
    }
    return sum / frequencyData.length;
};

/**
 * Draw waveform visualization on canvas
 */
export const drawWaveform = (canvas, frequencyData, isRecording, options = {}) => {
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;
    
    // Default colors
    const bgColor = options.bgColor !== undefined ? options.bgColor : (isRecording ? '#fed7d7' : '#f7fafc');
    const barColor = options.barColor || (isRecording ? '#f56565' : '#cbd5e0');
    const centerLineColor = options.centerLineColor || (isRecording ? '#c53030' : '#a0aec0');
    
    // Clear canvas
    ctx.clearRect(0, 0, width, height);
    
    // Draw background if specified
    if (bgColor !== 'transparent') {
        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, width, height);
    }
    
    // Calculate average level
    const avgLevel = getAudioLevel(frequencyData);
    
    // Draw bars
    const barWidth = width / frequencyData.length;
    
    for (let i = 0; i < frequencyData.length; i++) {
        const barHeight = (frequencyData[i] / 255) * height * 0.8;
        const x = i * barWidth;
        const y = height - barHeight;
        
        ctx.fillStyle = barColor;
        ctx.fillRect(x, y, barWidth - 1, barHeight);
    }
    
    // Draw center line
    ctx.strokeStyle = centerLineColor;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(0, height / 2);
    ctx.lineTo(width, height / 2);
    ctx.stroke();
};
